import TableCell from '@mui/material/TableCell';
import { ITableHeadCell } from 'components/@shared/TableRemotePagination/types';
import { ProposalResponseViewModel } from 'types/proposal';

import { ProposalListCell } from './ProposalListCell';

interface Props {
    columns: ITableHeadCell[];
    rowData: ProposalResponseViewModel;
}

export const ProposalListRow = ({ columns, rowData }: Props) => (
    <>
        {columns.map((item) => (
            <TableCell id={item.id} key={item.field}>
                <ProposalListCell {...{ item, rowData }} />
            </TableCell>
        ))}
    </>
);
